<template>
  <div class="comp-common-search">
    <!-- 保存常用检索的弹窗：新建、编辑、快捷带入 -->
    <jw-modal :visible="data.visible" @cancel="handleCancel" title-align="start" width="750px" :title="data.title" :on-before-ok="handleOk" :ok-text="$t('保存')" mask :mask-closable="false" :ok-loading="data.loading" unmount-on-close click-outside-to-close>
      <jw-form :model="form" auto-label-width ref="commonSearchRef" @submit="handleSubmit" label-align="left">
        <jw-form-item field="sceneName" :label="`${$t('场景名称')}:`" :label-col-style="{ width: '120px' }" :rules="[{ required: true, message: $t('请选择数据范围') }]" asterisk-position="end">
          <jw-input v-model="form.sceneName" :input-attrs="{ type: 'search' }" :name="'conditionschildren'" :placeholder="$t('请输入场景名称')" :max-length="50" :style="{ width: '280px', marginRight: '10px' }" />
        </jw-form-item>
        <jw-form-item :label="`${$t('数据范围')}:`" field="dataScope" :rules="[{ required: true, message: $t('请选择数据范围') }]" :validate-trigger="['blur', 'input', 'change']" :label-col-style="{ width: '120px' }" asterisk-position="end">
          <jw-select :trigger-props="{ updateAtScroll: true }" :style="{ width: '280px' }" v-model="form.dataScope" class="drop-down-select" popup-container=".comp-ly-advanced-filter" :allow-clear="false" allow-search :field-names="{ label: 'name', value: 'scope' }">
            <jw-option v-for="item in data.highList" :key="item.scope" :value="item.scope" :title="item.name">
              {{ item.name }}
            </jw-option>
          </jw-select>
        </jw-form-item>
        <jw-form-item :label="`${$t('筛选条件')}:`" style="max-height: 300px; overflow: auto" v-if="data.visible">
          <fh-custom-search-ultra ref="customFieldConditionRef" :entity="entity" :conditions="data.conditionList" @cb="getConditions" :headerIsBold="true" :noStyle="true" :showFooter="false" :needSplitDateRange="true"> </fh-custom-search-ultra>
        </jw-form-item>
        <jw-form-item :label-col-style="{ width: '180px' }">
          <jw-checkbox v-model="data.defaultCondition">设为默认常用检索</jw-checkbox>
        </jw-form-item>
      </jw-form>
    </jw-modal>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { publicService } from '@/api/';
import { Message } from '@arco-design/web-vue';
console.log('1-开始创建组件-setup');

const emits = defineEmits(['cb']);
const props = defineProps({
  entity: {
    type: [String, Number],
    default: 1
  }
});
const data = reactive({
  type: 1,
  title: '',
  highList: [],
  id: null,
  visible: false,
  loading: false,
  defaultCondition: true,
  conditionList: []
});

const commonSearchRef = ref();
const customFieldConditionRef = ref();
const form = ref({
  sceneName: '',
  dataScope: 0
});
// 打开弹窗
const openDialog = (params) => {
  console.log(56, params, data);
  // 1新增2编辑3快捷带入
  data.type = params.type;
  data.highList = params.highList?.filter((v) => v.type === 0);
  const record = params.record;
  if (data.type === 2) {
    data.id = record.id;
    data.title = '编辑常用检索';
    data.defaultCondition = record.isDefault;
    form.value.sceneName = record.name;
    form.value.dataScope = record.scope;
    data.conditionList = params.record?.conditions || [];
  } else if (data.type === 1) {
    data.title = '新建常用检索';
    data.defaultCondition = false;
    form.value.sceneName = '';
    form.value.dataScope = 0;
  } else if (data.type === 3) {
    data.title = '保存常用检索';
    data.defaultCondition = false;
    form.value.sceneName = '';
    form.value.dataScope = 0;
    data.conditionList = params.conditionList || [];
  }
  data.visible = true;
};
// 取消弹窗
const handleCancel = () => {
  data.conditionList = [];
  data.id = null;
  data.defaultCondition = false;
  form.value.sceneName = '';
  form.value.dataScope = 0;
  data.visible = false;
};
// 确定按钮
const handleOk = () => {
  commonSearchRef.value.handleSubmit();
  return false;
};
const validateData = (data) => {
  return data.every((group) => {
    return group.children.every((child) => {
      if (!child.field) {
        return false;
      }
      if (child.operation === 'null' || child.operation === 'not_null') {
        return true;
      } else {
        if (child.value || child.value === 0) {
          return true;
        } else {
          return false;
        }
      }
    });
  });
};

// 表单提交
const handleSubmit = ({ values, errors }) => {
  console.log('values', values);
  if (errors) {
    const errorArray = {};
    Object.values(errors).forEach((key, index) => {
      errorArray[key.field] = { status: 'error', message: '' };
      Object.values(errorArray).forEach((i, ind) => {
        if (index === ind) {
          i.message = key.message;
        }
      });
    });
    commonSearchRef.value.setFields(errorArray);
    return;
  }
  addConditionSave();
};
const addConditionSave = async () => {
  if (form.value.dataScope !== 0) {
    // 0 全部数据
    if (!validateData(data.conditionList)) {
      Message.warning('请完善筛选条件');
      return;
    }
  }

  data.loading = true;
  const conditionList = await customFieldConditionRef.value.getAllConditions();
  if (!conditionList) {
    data.loading = false;
    return;
  }
  try {
    const params = {
      id: data.type === 2 ? data.id : undefined,
      entity: props.entity,
      name: form.value.sceneName,
      scope: form.value.dataScope,
      conditions: conditionList,
      isDefault: data.defaultCondition
    };
    let conditionApi = 'addConditionSave';
    if (data.type === 2) conditionApi = 'updateCondition';
    const json = await publicService?.[conditionApi](params);
    if (!json.error) {
      console.log(95, json.result);
      emits('cb', { type: 1, condition: data.conditionList, id: data.type === 2 ? data.id : undefined });
      Message.success('操作成功');
      handleCancel();
    } else {
      Message.error(json.error?.msg);
    }
    data.loading = false;
  } catch (e) {
    data.loading = false;
    console.log(e);
  }
};
const getConditions = async (record) => {
  console.log('常用检索', record);
  data.conditionList = record;
};
defineExpose({ openDialog });
console.log(data, name);
</script>
<style scoped lang="less">
@import './common-search.less';
</style>
